import React, { useState } from 'react'
import config from '../../../config.json'
import printConfig from '../../../print-config.json'
import Translation from '../../Translation/cont/Translation';
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple';
import ChooseWeekButtons from '../../general/ChooseWeekButtons';
import { FLYER, NEWSPAPER } from '../../../constants/printType';
import { ErrorMessage, Form, Formik } from 'formik';
import DatepickerContainer from '../../forms/fields/DatepickerContainer';
import { Link } from 'react-router-dom';

const ChooseWeek = ({
    features,
    activeWeek, 
    weeks, 
    cinemaId,
    printType, 
    printID, 
    printPk,
    newspaperData,
    printUpdateRequest,
    landscape,
    closePagePath,
    flyerServerData,
    printToolSetWeek,
    printToolAddDatePeriod
}) => {
    if(!features) {
        return ''
    }

    const [showError, setShowError] = useState(false)
    const landscapeBoolean = landscape === "true"
    const currentPrintFormat = _.findWhere(printConfig.formats, { path: printID, landscape: landscapeBoolean })
    let flyerData
    let initValues
    let dateSettingsValues = {
        startDate:'',
        endDate:''
    }

    if(printType === FLYER) {
        flyerData = flyerServerData.flyers ? flyerServerData.flyers[printPk] : null
        initValues = flyerData && flyerData.dateSettings ? flyerData.dateSettings : dateSettingsValues
    } else if(printType === NEWSPAPER){
        initValues = newspaperData && newspaperData.dateSettings ? newspaperData.dateSettings : dateSettingsValues
    }

    return (
        <WrapperPageSimple
            pageTitleTransId={printConfig.routes[printType].transIdname} 
            pageTitle={flyerData && flyerData.flyerSettings.name ? flyerData.flyerSettings.name : null} 
            closePagePath={closePagePath}
        >
            <div className="program-page program-page-sorting-movies flyer print-page site-content">
                <div>
                    <h3 className="gap-20 title-list text-regular"><Translation id="print_flyer_select_week">Spielwoche auswählen</Translation></h3>

                    <ChooseWeekButtons
                        activeWeek={parseInt(activeWeek)}
                        weeks={weeks} 
                        path={`${config.routes.webtoprint.path}/${cinemaId}/${printType}/${currentPrintFormat.path}/${printPk}/${currentPrintFormat.landscape}`}
                        pathAfterWeek='edit'
                        updateWeek={printToolSetWeek}
                        activeWeekIsLink={true}
                    />

                    {(printType === FLYER || printType === NEWSPAPER) && (flyerData || newspaperData) && <>
                        {<Formik
                            initialValues={initValues}
                            onSubmit={(values, actions) => {
                                if((!values.endDate && values.startDate) || (values.endDate && !values.startDate)) {
                                    setShowError(true)
                                } else {
                                    setShowError(false)
                                }
                                
                                if(printType === NEWSPAPER) {
                                    if((!values.endDate && !values.startDate)) {
                                        printToolAddDatePeriod(null)
                                    } else{
                                        printToolAddDatePeriod(values)
                                    }
                                } else {
                                    if((!values.endDate && !values.startDate)) {
                                        printToolAddDatePeriod(null, flyerData.pk)
                                    } else{
                                        printToolAddDatePeriod(values, flyerData.pk)
                                    }
                                }
                            }}
                        >
                        {({values, errors, touched, isSubmitting, handleReset, setFieldValue, submitForm}) => 
                            <Form>
                                <div className="datepicker-container add-custom-period gap-20">
                                    <div className="datepicker-wrapper">
                                        <DatepickerContainer
                                            name={"startDate"} 
                                            onChange={setFieldValue}
                                            submitOnChange={() => setTimeout(submitForm, 0)}
                                            value={values.startDate}
                                            resetValue={'endDate'}
                                            isStartDate={true}
                                            type="text" 
                                            id="startDate" 
                                            start={values.startDate}
                                            end={values.endDate}
                                            />
                                        <ErrorMessage className="text-regular-color" name="startDate" component="div" />  
                                    </div>
                                    <div className="datepicker-wrapper">
                                        <DatepickerContainer
                                            name={"endDate"} 
                                            submitOnChange={() => setTimeout(submitForm, 0)}
                                            onChange={setFieldValue}
                                            value={values.endDate}
                                            end={values.endDate}
                                            start={values.startDate}
                                            type="text" 
                                            id="endDate"
                                        />
                                        <ErrorMessage className="text-regular-color" name="endDate" component="div" />  
                                    </div>
                                </div>
                            </Form>
                        }
                        </Formik>}
                        {showError && <Translation id="formik_field_required">Dieses Feld wird benötigt!</Translation>}
                        {((flyerData && flyerData.dateSettings && flyerData.dateSettings.startDate && flyerData.dateSettings.endDate) || (newspaperData && newspaperData.dateSettings && newspaperData.dateSettings.startDate && newspaperData.dateSettings.endDate)) && <Link className={"button-wrapper button"} to={`${config.routes.webtoprint.path}/${cinemaId}/${printType}/${currentPrintFormat.path}/${printPk}/${currentPrintFormat.landscape}/custom/edit`}>
                            {(flyerServerData.hasChanges || newspaperData.hasChanges) ? (
                                <button onClick={() => {printUpdateRequest()}} className={"button button-text"}><Translation id="print_flyer_use_custom_date_period"/></button>
                            ) : (
                                <div className={"button-text"}><Translation id="print_flyer_use_custom_date_period"/></div>
                            )}
                        </Link> }
                    </>}
                </div>
            </div>
        </WrapperPageSimple>
    )
}

export default ChooseWeek